/**
 * Created: 2026-05-05
 * Initial commit: Add coupon templates management page
 *
 * Shared label maps for domain enums used across the frontend.
 */

import { CouponCategory, SportCategory } from '../gql/graphql'

export const COUPON_CATEGORY_LABEL: Record<CouponCategory, string> = {
  [CouponCategory.FreeSlot]: '免费订场',
  [CouponCategory.FreeSignup]: '免费报名',
  [CouponCategory.FixedDiscount]: '固定折扣',
}

export const SPORT_LABEL: Record<SportCategory, string> = {
  [SportCategory.Tennis]: '网球',
  [SportCategory.Pickleball]: '匹克球',
}
